
export function tableParamNav(
  current: URLSearchParams,
  key: string,
  next: string | number,
): { replace: boolean } {
  const existing = current.get(key);
  return { replace: existing === null || existing === String(next) };
}
